import React from 'react';

import type { TaskShape } from '../../types';

import { ActiveTask } from './components/ActiveTask';
import { CompletedTask } from './components/CompletedTask';
import { DownloadFlyerTaskLoader } from './components/DownloadFlyerTaskLoader';
import { useTask } from './hooks/useTask';

type TaskProps = TaskShape;
export const Task: React.FC<TaskProps> = ({ status, name, ...rest }) => {
	const { data } = useTask();
	// TODO: Other state tasks go here
	switch (status) {
		case 'ACTIVE': {
			// TEMPORARY: this is not ideal, but the download_flyer task is using a PDF library that is too large
			// to be included in the page bundle. So we're lazy loading it for now until we move the PDF generation
			// to non-react land (server-side or loading it in pure JS)
			if (name === 'download_flyer' && !data.showMultiDownloadFlyersTask)
				// DownlyadFlyer wasn't reskined so we are keeping the old component for now
				return <DownloadFlyerTaskLoader name={name} {...rest} />;

			return <ActiveTask name={name} {...rest} />;
		}
		case 'COMPLETED':
			return <CompletedTask name={name} {...rest} />;
		case 'IGNORED':
			return null;
		default:
			return null;
	}
};
